<template>
  <div>
    <section class="container">
      <template v-if="!formLoading && error.active">
        <div class="columns is-desktop is-centered">
          <div class="column is-8">
            <b-message
              :title="error.error"
              type="is-danger"
              aria-close-label="Close message"
              :active.sync="error.active"
            >{{ error.message }}</b-message>
          </div>
        </div>
      </template>
      <div class="columns is-desktop is-centered">
        <div class="column is-8">
          <form-wizard @on-complete="onComplete" stepSize="xs" color="#004771">
            <h2 class="title" style="color:#004771" slot="title">Report a claim</h2>
            <tab-content
              title="Start"
              icon="ti-angle-double-right"
              :before-change="validateFirstTab"
            >
              <basic-info :fnoldata="fnoldata"></basic-info>
            </tab-content>
            <tab-content title="Policy" icon="ti-filter" :before-change="validateSecondTab">
              <policy-info
                :policy="fnoldata.policy"
                :message="message"
                :injurydate="fnoldata.injury.dateOfInjury"
              ></policy-info>
            </tab-content>
            <tab-content title="Employer" icon="ti-link" :before-change="validateThirdTab">
              <div class="column is-full">
                <b-message type="is-danger" has-icon v-if="!fnoldata.id">
                  <h1 class="title is-4">We
                    <u>could not</u> proceed further due to an unknown error! </h1>
                    <p>Please try again! if you encounter the same error you may contact Republic Indemnity claim Reporting at (800) 821-4520.
                 </p>
                  <br />
               <br />
                <center>
                 <router-link to="/" >Go Home</router-link></center>
                 </b-message>
           <div class="column is-full" v-else>
              <b-notification role="alert">
                <b>Date of Injury:</b>
                &nbsp;{{getDateFormatted(fnoldata.injury.dateOfInjury)}}
                <br />
                <b>Policy Number:</b>
                &nbsp;{{fnoldata.policy.policyNumber}}
                <br />
                <b>FNOL Submission ID:</b>
                &nbsp;{{fnoldata.id}}
                <br />
              </b-notification>
              <employer-info :fnoldata="fnoldata" ></employer-info>
           </div>
              </div>
            </tab-content>
            <tab-content title="Injured Worker" icon="ti-user" :before-change="validateForthTab">
              <b-notification role="alert">
                <b>Date of Injury:</b>
                &nbsp;{{getDateFormatted(fnoldata.injury.dateOfInjury)}}
                <br />
                <b>Policy Number:</b>
                &nbsp;{{fnoldata.policy.policyNumber}}
                <br />
                <b>FNOL Submission ID:</b>
                &nbsp;{{fnoldata.id}}
                <br />
              </b-notification>
              <injured-worker-info :fnoldata="fnoldata"></injured-worker-info>
            </tab-content>
            <tab-content title="Details" icon="ti-layers" :before-change="validateFifthTab">
              <b-notification role="alert">
                <b>Date of Injury:</b>
                &nbsp;{{getDateFormatted(fnoldata.injury.dateOfInjury)}}
                <br />
                <b>Policy Number:</b>
                &nbsp;{{fnoldata.policy.policyNumber}}
                <br />
                <b>FNOL Submission ID:</b>
                &nbsp;{{fnoldata.id}}
                <br />
              </b-notification>
              <injury-details :fnoldata="fnoldata"></injury-details>
            </tab-content>
            <tab-content title="Last step" icon="ti-check">
              <summary-info :fnoldata="fnoldata"></summary-info>
            </tab-content>
            <b-notification
              :active.sync="acceptAgreement"
              type="is-danger"
              aria-close-label="Agreement notification"
              role="alert"
            >Please accept agreement before proceeding.</b-notification>
            <b-notification
            has-icon
              :active.sync="allValidations"
              type="is-danger"
              aria-close-label="Nofication Message For All Validations"
              role="alert"
            >{{this.validationMessage}}</b-notification>
            <button class="button is-warning" style="width: 100px;" slot="prev">Back</button>
            <button class="button is-warning" style="width: 100px;" slot="next">Next</button>
            <button class="button is-danger" :disabled="this.isThisSubmitted" style="width: 100px;" slot="finish">Finish</button>
          </form-wizard>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VeeValidate from "vee-validate";

import Vue from "vue";
import Buefy from "buefy";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import EmployerInfo from "./EmployerInfo.vue";
import PolicyInfo from "./PolicyInfo.vue";
import BasicInfo from "./BasicInfo.vue";
import InjuredWorkerInfo from "./InjuredWorkerInfo.vue";
import InjuryDetails from "./InjuryDetails.vue";
import Summary from "./Summary.vue";

import { InitClaim, FileClaim } from "../utils/services";

import moment from "moment";

Vue.use(VueFormWizard);
Vue.use(Buefy);
const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: "errors", // change if property conflicts
  events: "input|blur",
  fieldsBagName: "fields",
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: "validations", // the nested key under which the validation messages will be located
  inject: true,
  locale: "en",
  validity: false,
  useConstraintAttrs: true
};

Vue.use(VeeValidate, config);

export default {
  name: "bueforms",
  provide() {
    return { parentValidator: this.$validator };
  },
  components: {
    "employer-info": EmployerInfo,
    "policy-info": PolicyInfo,
    "basic-info": BasicInfo,
    "injured-worker-info": InjuredWorkerInfo,
    "injury-details": InjuryDetails,
    "summary-info": Summary
  },
  data() {
    return {
      message: {
        displaynp: false
      },
      isThisSubmitted: false,
      acceptAgreement: false,
      validationMessage:'',
      allValidations:false,
      error: {
        active: false,
        message: "",
        error: false,
        status: 200
      },
      fnoldata: {
        id: "",
        jurisdictionState: "",
        tosAgreement: false,
        source: "Public",
        currentDate: new Date(),
        taxIdentifiers: {
          fein: ""
        },
        policy: {
          policyNumber: "",
          npAgreement: false,
          state: null,
          effectiveDate: null,
          expirationDate: null
        },
        preparer: {
          fname: "",
          lname: "",
          name: "",
          title: null,
          notifyBy: "Phone",
          phone: {
            work: ""
          },
          email: ""
        },
        injury: {
          dateOfInjury: null,
          timeOfInjury: new Date(),
          dateReportedToEmployer: null,
          dateFormGivenToEmployer: null,
          detailedInjury: null,
          bodyPart: null,
          locationEventOccured: "",
          onEmployerPremises: "No",
          injEquip: "",
          injActivty: "",
          beganWrkStartTime: null,
          dateofDeath: null,
          rbOneDay: "No",
          dateLastWeekWorked: null,
          employeeReturnedToWork: null,
          rbInjoffWk: "No",
          employeeSalaryContinuted: "No",
          medicalDiagnosis: "",
          locationCounty: "",
          departmentCode: "",
          rbOthInj: "No",
          claimInjuryDescription: "",
          seekMedicalTreatment: "No",
          hospitaliz: "No",
          employeePaidInjuryDay: "No"
        },
        employer: {
          name: "",
          email: "",
          contactName: "",
          empInformed: "No",
          address: {
            street: "",
            city: "",
            state: "",
            country: "USA",
            zip: ""
          },
          phone: {
            work: "",
            fax: ""
          },
          isEmployerLocationDifferent: false,
          isAddressDifferent: false
        },
        employee: {
          lastName: "",
          firstName: "",
          middleInitials: "",
          ssn: "",
          dateOfBirth: null,
          address: {
            street: "",
            city: "",
            state: "",
            country: "USA",
            zip: ""
          },
          phone: {
            mobile: ""
          },
          gender: null
        },
        employment: {
          occupation: "",
          dateOfHiring: "",
          employmentStatus: "",
          employmentClassCode: "",
          grossWages: "",
          grossWagePer: "",
          hoursPerDay: null,
          daysPerWeek: null,
          totalWeeklyHours: null,
          opy: "No"
        },
        physicianORClinic: {
          name: "",
          address: {
            street: "",
            city: "",
            state: null,
            country: "USA",
            zip: ""
          },
          phone: {
            work: ""
          }
        },
        hospital: {
          name: "",
          emergency: "No",
          address: {
            street: "",
            city: "",
            state: null,
            country: "USA",
            zip: ""
          },
          phone: {
            work: ""
          }
        }
      }
    };
  },
  methods: {
    onComplete: function() {
      // FileClaim( this.getJsonToString(this.fnoldata) );
      // TODO:  Prepare Data to be saved.
      // TODO:  Save Data
      if (this.fnoldata.tosAgreement) {
        if (this.fnoldata.id) {
          const id = this.fnoldata.id;
          //alert(id);
          // todo :  save init data
          this.isThisSubmitted=true;
          FileClaim(this.fnoldata)
            .then(res => {
              this.fnoldata = {};
              this.$router.push({ name: "completed", params: { id } });
            })
            .catch(err => {
              this.isThisSubmitted=false;
              alert(err);
            });
        } else {
          alert("Cannot submit, missing submission id!");
        }
      } else {
        this.acceptAgreement = true;
      }
    },

    getDateFormatted: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY hh:mm A");
      }
    },

    validateComp(comp) {
      alert(comp);
      return this.$validator.validateAll(comp);
    },
    validateFirstTab: function() {
      if(this.fnoldata.preparer.notifyBy == "Email"){
        if(this.fnoldata.preparer.email == ""){
        this.allValidations = true;
        this.validationMessage= "You have asked us to notify by email. Please provide an email address to proceed further.";
        return "false";
      }else {
        this.allValidations = false;
        return this.$validator.validateAll("basics");
          }
      }else if(this.fnoldata.preparer.notifyBy == "Phone"){
        this.allValidations = false;
        return this.$validator.validateAll("basics");
        }
    },

    validateSecondTab: function() {
      // if (this.message.displaynp) {
      //   if (!this.fnoldata.policy.npAgreement) {
      //     this.$toast.open({
      //       message:
      //         "Please accept via selecting the checkbox, before proceeding.",
      //       type: "is-danger",
      //       position: "is-top"
      //     });
      //     return false;
      //   }
      // }
      return this.$validator.validateAll("policy").then(value => {
        var ok2Proceed = false;
        if (value) {
          //ValidatePublicPolicy(param);
          ok2Proceed = this.displayNPDisclaimer();
        }
        if (ok2Proceed) {
          // todo :  save init data
          if (!this.fnoldata.id) {
            InitClaim(this.fnoldata)
              .then(res => {
                this.fnoldata.id = res.tempid;
                //alert(JSON.stringify(res));
              })
              .catch(err => {
                alert(err);
              });
          }
        }
        return ok2Proceed;
      });
    },
    validateThirdTab: function() {
      if(this.fnoldata.id == ""){
        return "false";
      }else{
        return this.$validator.validateAll("employer");
      }

    },
    validateForthTab: function() {
      var injuredDate = this.fnoldata.injury.dateOfInjury;
      var dateOfBirth = this.fnoldata.employee.dateOfBirth;
      var dateOfHire = this.fnoldata.employment.dateOfHiring;
      if (dateOfBirth > injuredDate) {
        this.allValidations = true;
        this.validationMessage= "Date Of Birth Cannot be greater than Date of Injury.";
        return "false";
      } else if(dateOfHire != ""){
      if(dateOfBirth > dateOfHire){
        this.allValidations = true;
         this.validationMessage= "Date Of Hire Cannot be less than the Date of Birth.";
        return "false";
      }else if(dateOfHire > injuredDate){
        this.allValidations = true;
         this.validationMessage= "Date Of Hire Cannot be greater than the Date of Injury.";
        return "false";
        } else{
         this.allValidations = false;
        return this.$validator.validateAll("employee");
        }
      }else{
        this.allValidations = false;
        return this.$validator.validateAll("employee");
      }
    },
    validateFifthTab: function() {
      // alert("this a alert for validateform5");
      return this.$validator.validateAll("injurydetails");
    },
    displayNPDisclaimer() {
      if (
        this.message.displaynp === false &&
        this.fnoldata.policy.policyNumber.length == 0
      ) {
        this.message.displaynp = true;
        return false;
      } else {
        if (this.message.displaynp == true) {
          return this.fnoldata.policy.npAgreement;
        } else {
          return true;
        }
      }
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$toast.open({
            message: "Form is valid!",
            type: "is-success",
            position: "is-bottom"
          });
          return;
        }
        this.$toast.open({
          message: "Form is not valid! Please check the fields.",
          type: "is-danger",
          position: "is-bottom"
        });
      });
    }
  },
  watch: {
    "fnoldata.policy.state": function(val) {
      this.fnoldata.jurisdictionState = val;
    }
    // "fnoldata.injury.dateOfInjury": function(val) {
    //   if (this.fnoldata.policy.policyNumber != "") {
    //     //alert("clear our policynumber now");
    //     this.fnoldata.policy.policyNumber = "";
    //     this.fnoldata.policy.npAgreement = false;
    //   }
    // }
  }
};
</script>
<style>
.label {
  text-align: left;
  white-space: normal;
  padding: 0;
}
.help.is-danger {
  margin: 2px 20px 0px 0px;
}

p.help {
  margin: 2px 20px 0px 0px;
}
</style>
